export const formatPlayerTime = (time: number): string => {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const formatSplitterTime = (point: number, duration: number): string => {
  const time = (point * duration) / 100;

  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const scalePoints = (points: number, duration: number) => {
  return (points / duration) * 100;
};

export const scalledHeight = (duration: number) => {
  let SCALE_FACTOR = 50;
  if (duration < 60) SCALE_FACTOR = 80;
  if (duration > 60 && duration < 600) SCALE_FACTOR = 8;
  if (duration > 600) SCALE_FACTOR = 5;
  return duration * SCALE_FACTOR;
};
